import { DateTimeString, IdentifiableBase, IpDate } from '@ipensii/shared/domain-shared';
import { StringUtils } from '@ipensii/shared/util-shared';

export interface Exception extends IdentifiableBase {
  createdAt: DateTimeString;
  systemName: string;
  message: string;
  truncatedStackTrace: string;
  stackTrace: string;
  createdBy: string;
}

export class ExceptionImpl implements Exception {
  constructor(
    public readonly uuid: string,
    public readonly createdAt: DateTimeString,
    public readonly systemName: string,
    public readonly message: string,
    public readonly truncatedStackTrace: string,
    public readonly stackTrace = '',
    public readonly createdBy: string
  ) {}

  static fromError(error: Error, createdBy: string | null): Exception {
    return new ExceptionImpl(
      '',
      new IpDate().toDateTimeString(),
      'webClient',
      error.message,
      StringUtils.truncate(error.stack, '\n', 2),
      error.stack,
      createdBy || ''
    );
  }
}
